export default __webpack_public_path__ + "static/media/DeQueue.36c5c09f.gif";